import { FC } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { useStoreSelector } from "../../store/store";
import { blockchain } from "../../settings";

import Background from "../UI/Background/Background";
import StartUpPage from "../StartUpPage/StartUpPage";
import MainPage from "../MainPage/MainPage";
import SettingsPage from "../SettingsPage/SettingsPage";
import MainUpdater from "../utilComponents/MainUpdater/MainUpdater";
import ChromiaRegisterPage from "../ChromiaRegisterPage/ChromiaRegisterPage";
// import Spinner from "../UI/spinner/spinner";

import './App.scss';

/* const ClientPage = lazy(() => import("../client_page/client_page"));
const HistoryPage = lazy(() => import("../history_page/history_page"));
const LeaderboardPage = lazy(() => import("../leaderboard_page/leaderboard_page"));
const PingPage = lazy(() => import("../ping_page/pingPage"));
const StatisticsPage = lazy(() => import("../statistics_page/statistics_page")); */


const App: FC = () => {

	const {isInited} = useStoreSelector(store => store.app);
	const {isChrRegistered} = useStoreSelector(store => store.chromia);


	return (
		/* <Suspense
			fallback={<Spinner/>}
		> */
		<div className="App">
			<Background/>
				{!isInited?
					<StartUpPage/>
				:
					(blockchain === 'chromia' && !isChrRegistered)?
						<ChromiaRegisterPage/>
					:
						<>
							<Switch>
								{/* <Route exact path='/ping' component={PingPage} />
								<Route exact path='/history' component={HistoryPage}/>
								<Route exact path='/leaderboard' component={LeaderboardPage}/>
								<Route exact path='/statistics' component={StatisticsPage}/> */}
								<Route exact path='/' component={MainPage}/>
								<Route exact path='/settings' component={SettingsPage}/>
								<Redirect to='/'/>
							</Switch>
							<MainUpdater/>
						</>
				}
		</div>
		// </Suspense>
	)
}

export default App;